module.exports = __webpack_public_path__ + "img/collection-engagementRingsBudgetHigh.d887d02.jpg";